// unprotected routes
import LoginLayout from '@/common/layout/login-layout';
import MainLayout from '@/common/layout/main-layout';
import ErrorComponent from '@/components/error/error-component';
import getValidAuthRoutes from '@/utils/auth-routes';
import { APP_CONTEXT } from '@/utils/context';
import { useContext, useMemo } from 'react';
import {
  RouterProvider,
  createBrowserRouter,
  Navigate,
} from 'react-router-dom';
import AuthRoutes from './auth-routes';
import GeneralRoutes from './general-routes';
import ShopAuthRoutes from './shop-routes';

/**
 * The Main Routes component to handle protected and unprotected routes.
 * @returns {JSX.Element} The Main Routes component.
 */
const AppRoutes = () => {
  const { permissions, isSuper, currentUser } = useContext(APP_CONTEXT);
  const Routes = useMemo(() => {
    let authRoutes = AuthRoutes;
    let shopRoutes = ShopAuthRoutes;
    if (currentUser) {
      if (currentUser.user_type === 'user') {
        authRoutes = getValidAuthRoutes(AuthRoutes, permissions, isSuper);
      } else {
        authRoutes = [
          {
            path: '*',
            element: <Navigate to="shop" />,
          },
        ];
      }
      if (currentUser.user_type === 'company') {
        shopRoutes = getValidAuthRoutes(ShopAuthRoutes, permissions, isSuper, {
          company_user_type: currentUser.company_type,
          is_dealer: currentUser.is_dealer,
          is_supplier: currentUser.is_supplier,
        });
      }
    }
    return [
      {
        path: '/',
        element: <LoginLayout />,
        errorElement: <ErrorComponent />,
        children: GeneralRoutes, // not logged in routes
      },
      {
        path: '/app',
        element: <MainLayout />,
        errorElement: <ErrorComponent />,
        children: authRoutes, // logged in routes
      },
      {
        path: '/shop',
        element: <MainLayout />,
        errorElement: <ErrorComponent />,
        children: shopRoutes, // logged in routes
      },
    ];
  }, [currentUser, isSuper, permissions]);

  const router = createBrowserRouter(Routes);
  return <RouterProvider router={router} />;
};

export default AppRoutes;
